import logger from 'src/log/log';

export const forceString = (value: any) => {
  if (typeof value !== 'string') {
    logger.error('Value is not a string', { value });
    return '';
  }
  return value;
};
